import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-file-list-picture",
  "use": "icon-file-list-picture-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-file-list-picture\"><defs><style type=\"text/css\"></style></defs><path d=\"M96 896q-14.016 0-23.008-8.992T64 864V160q0-14.016 8.992-23.008T96 128h832q14.016 0 23.008 8.992T960 160v704q0 14.016-8.992 23.008T928 896H96z m316-228l-68.992-68.992q-10.016-10.016-23.008-10.016t-23.008 10.016L128 768h779.008l-242.016-290.016q-10.016-12-24.992-12t-24.992 12l-156 187.008q-8.992 11.008-23.008 11.488t-24-8.512zM256 384q0 26.016 12.992 48t35.488 35.008 47.488 12.992 48-12.992 35.488-35.008 12.512-48q-0.992-40.992-28-68t-68-27.008-68 27.008T255.968 384z\" p-id=\"9939\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/file-list-picture.svg
// module id = 4Fln
// module chunks = 20